import React, { Component } from "react";
import "./ImageLoader.css";

class ImageLoader extends Component {
    render() {
        return (
            <div className="loader-container">
                <div className="loader"></div>
            </div>
        );
    }
}

export default ImageLoader;